import { Panel } from '../../ui/Panel';
import { Field } from '../../ui/Field';
import { TagInput } from '../../ui/TagInput';
import { useAdmin } from '../../AdminContext';
import { MAX_HASHTAGS, platformMeta } from '../socialOptions';
import { inputCls } from '../../ui/styles';
import type { SocialPost } from '../../../core/types/social';
type Props = {
  post: SocialPost;
  set: (patch: Partial<SocialPost>) => void;
  /** Lengte van de tekst zoals hij geplakt wordt (met hashtags). */
  textLength: number;
  limit?: {
    max: number;
  };
};

/** Tekst, hashtags, eerste reactie en link: alleen wat de gekozen kanalen gebruiken. */
export function PostTextPanel({
  post,
  set,
  textLength,
  limit
}: Props) {
  const {
    marketing
  } = useAdmin();
  const has = (x: SocialPost['platforms'][number]) => post.platforms.includes(x);
  const wantsLink = post.platforms.some(x => platformMeta[x].link !== 'bio');
  return <Panel title="Tekst" description="Slimme woorden zoals {firstName} en {city} vullen zich vanzelf in." data-id="element-4549" data-mp="1d1vtycefp66">
      <div className="space-y-5" data-id="element-4550" data-mp="1hy6dvqw5z166">
        {post.platforms.some(x => platformMeta[x].caption) ? <Field label="Tekst bij het bericht" hint="Begin met een zin die nieuwsgierig maakt: alleen de eerste regel staat boven “meer”." count={limit ? {
        value: textLength,
        max: limit.max
      } : undefined} data-id="element-4551" data-mp="1mwr7v8ktoom6">
            <textarea value={post.caption} onChange={e => set({
          caption: e.target.value
        })} rows={8} placeholder="Wat wil je vertellen?" className={`${inputCls} resize-y leading-relaxed`} data-id="element-4552" data-mp="1vwwcjaymt8wn" />
          </Field> : <p className="text-[13px] text-muted" data-id="element-4553" data-mp="186tk2tqt20xi">Een Instagram-story heeft geen tekst eronder: de tekst staat in het beeld.</p>}

        {has('Instagram-post') && <>
            <Field label="Hashtags" as="div" count={{
          value: post.hashtags.length,
          max: MAX_HASHTAGS
        }} hint="3 tot 8 gerichte werkt het best. Lokaal (#drenthe) helpt ook." data-id="element-4554" data-mp="ggfctgdarmut">
              <TagInput label="Hashtags" value={post.hashtags} onChange={tags => set({
            hashtags: tags.map(h => h.startsWith('#') ? h : `#${h}`)
          })} suggestions={marketing.brandKit.hashtags.filter(h => !post.hashtags.includes(h)).slice(0, 10)} data-id="element-4555" data-mp="1nsei9hy67alo" />
            </Field>
            <Field label="Eerste reactie" hint="Optioneel: een vraag aan je volgers, of extra uitleg. Plaats je direct na het posten." data-id="element-4556" data-mp="1smirk7uwrupx">
              <input value={post.firstComment} onChange={e => set({
            firstComment: e.target.value
          })} className={inputCls} data-id="element-4557" data-mp="zwahl3aj0gmf" />
            </Field>
          </>}

        {wantsLink && <Field label={has('Instagram-story') ? 'Link (voor de linksticker)' : 'Link'} hint="Bijv. naar een product, protocol of het huidadvies." data-id="element-4558" data-mp="19t5a95k4bmss">
            <input type="url" inputMode="url" value={post.link} onChange={e => set({
          link: e.target.value
        })} placeholder="https://beautybewust.nl/webshop" className={inputCls} data-id="element-4559" data-mp="2p8m3g2zamfvs" />
          </Field>}
      </div>
    </Panel>;
}